const config = {
  //server_ip: "http://localhost:4000",
  //server_ip: "https://cardio4allapi.phormuladev.com",
  server_ip: "https://api.cardio4all.pt",
};

export default config;
